import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import { slug } from 'utils/general'
import validate from 'mixins/validate'

Vue.component('form-stock-notification', resolve => {
  Promise.all([
    enqueueModule('checkbox.vue')
  ]).then(() => {
    resolve({
      mixins: [validate],
      props: [
        'url',
        'group',
        'errorText',
        'successText',
        'apiKey',
        'productId'
      ],
      data () {
        return {
          query: {
            a: this.apiKey,
            variant: '',
            product: this.productId,
            platform: 'shopify',
            subscribe_for_newsletter: false,
            g: this.group,
            email: ''
          },
          response: false,
          hasError: false,
          optionsArr: [
            false,
            false,
            false
          ]
        }
      },
      mounted () {
        this.query.variant = this.activeVariant.id

        this.initialOptions()
      },
      computed: {
        ...mapState('product', [
          'product',
          'optionsMap'
        ]),
        ...mapState('product', [
          'activeVariant'
        ]),
        options () {
          return this.optionsMap
        }
      },
      methods: {
        initialOptions () {
          this.optionsArr = [this.activeVariant.option1, this.activeVariant.option2, this.activeVariant.option3]
        },
        onSelectChange ({ value, name }) {
          const index = this.product.optionNames.indexOf(name)
          this.optionsArr[index] = value

          this.changeVariant()
        },
        changeVariant () {
          const filterEmptyValues = this.optionsArr.filter(x => x !== 'false')
          const variantTitle = filterEmptyValues.join(' / ')
          const variant = this.product.variants.find(variant => {
            return variant.title === variantTitle
          })

          if (variant) {
            this.query.variant = variant.id

            this.checkButtonStatus(variant.available)
          } else {
            this.checkButtonStatus(false, true)
          }
        },
        checkButtonStatus (available, staticDisable = false) {
          const button = this.$refs['referendum']

          if (staticDisable) {
            button.disabled = true
          } else {
            button.disabled = ![false, 'false'].includes(available)
          }
        },
        onInputChange ({ value, name }) {
          if (name === 'email') {
            this.query.email = value
          }

          if (name === 'add_to_list') {
            this.query.subscribe_for_newsletter = !!value
          }
        },
        selectInitialValue (values) {
          let initialValue = values[0].value
          const option1 = this.activeVariant.option1
          const option2 = this.activeVariant.option2
          const option3 = this.activeVariant.option3

          values.forEach(x => {
            if (x.value === option1 || x.value === option2 || x.value === option3) {
              initialValue = x.value
            }
          })

          return initialValue
        },
        valueChange () {
          this.validItemsCount = this.$children
            .filter(c => (
              typeof c.validateInput === 'undefined' ||
              c.isValid
            )).length
        },
        slug (value) {
          return slug(value)
        },
        submit (e) {
          const isValid = this.validateAndDisplayErrors(e)

          if (!isValid) {
            return
          }

          const body = Object.keys(this.query).reduce((formData, key) => {
            formData.append(key, this.query[key])
            return formData
          }, new FormData())

          fetch(this.url, {
            method: 'POST',
            body
          })
            .then(res => res.text().then(text => this.responseHandler(res.status, text)))
            .catch(() => this.responseHandler(0, null))
        },
        responseHandler (status, data) {
          if (Number(status) !== 200) {
            this.response = this.errorText
            this.hasError = true
            return
          }
          const parsed = JSON.parse(data)
          if (parsed && parsed.success) {
            this.hasError = false
            this.response = this.successText
          } else {
            this.hasError = true
            this.response = this.errorText
          }
        }
      }
    })
  })
})
